import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { restaurantConfig } from 'restaurant'
import { ConfirmModal } from '@cps'
import { ProductImage } from 'components'
import './index.scss'
import { forEach, sumBy } from '@dt/fe-utils/dist/lodash'
import { TCartitemDisabledReason } from 'restaurant/mobx/center/restaurantCenter'
import { classNames } from '@dt/fe-utils'

interface IProps {
  cartItems: IViewCartItem[];
  resolve?: () => void;
  reject?: () => void;
}

const disabledTxtMaps = {
  [TCartitemDisabledReason.MAXSALESCNT]: 'cart.limitSale',
  [TCartitemDisabledReason.SOLDOUT]: 'cart.pause',
}

const ConfirmPreOrderModal: React.FC<IProps> = (props) => {
  const { resolve, cartItems, reject } = props
  const [totalCnt, setTotalCnt] = useState(0)
  const [soldCnt, setSoldCnt] = useState(0)
  const [maxCnt, setMaxCnt] = useState(0)

  const renderProduct = (products: IViewCartItem[]) => {
    return products?.map((item: IViewCartItem) => {
      return (
        <div className='product-item-wrapper' key={item.productNo + item.scaleNo}>
          <div className={classNames('product-item', { disabled: item.disabled })}>
            <ProductImage color={!item.pic && restaurantConfig.displayMode === 'waterfall' ? item.productNo : ''} width={40} imgSrc={item.pic} />
            <div className='product-name'>
              <strong>{item.name}</strong>
              <div className='product-option'>{item.optionStr}</div>
            </div>
          </div>
          {item.disabledReason ? <div className='disable-txt'>{i18n.t(disabledTxtMaps[item.disabledReason])}</div> : <div className='product-cnt'>x{item.cnt}</div>}
        </div>
      )
    })
  }

  useEffect(() => {
    let maxCnt = 0
    let soldCnt = 0
    let totalCnt = 0
    forEach(cartItems, (item) => {
      totalCnt += item.cnt
      if (item.disabled) {
        item.disabledReason === TCartitemDisabledReason.MAXSALESCNT && (maxCnt += item.cnt)
        item.disabledReason === TCartitemDisabledReason.SOLDOUT && (soldCnt += item.cnt)
      }
    })
    setTotalCnt(totalCnt)
    setSoldCnt(soldCnt)
    setMaxCnt(maxCnt)
  }, [])

  return (
    <ConfirmModal
      title={(
        <div>
          <span>{i18n.t('cart.preOrderWarn')}</span>
          <br />
          <span>{i18n.t('cart.preOrderWarn2')}</span>
        </div>
      )}
      cancelText={i18n.t('cart.reorder')}
      className='confirm-pre-order-modal'
      resolve={resolve}
      reject={reject}
    >
      <div className='product-total'>
        <span className='txt'>{i18n.t('cart.preOrderItems', { cnt: totalCnt })}{maxCnt > 0 ? ',' : ''}</span>
        {maxCnt > 0 && <span className='error txt'>{i18n.t('cart.preOrderMaxSalesCnt', { cnt: maxCnt })}</span>}
      </div>
      <div className='product-list'>
        {renderProduct(cartItems)}
      </div>
    </ConfirmModal>
  )
}

export default observer(ConfirmPreOrderModal)
